<template>
  <div class="icon icon-shape icon-primary icon-sm rounded-circle ml-3">
    <b-icon :icon="icon"></b-icon>
  </div>
</template>

<script>
export default {
  name: "Ic1",
  props: ["icon"],
};
</script>

<style scoped>

.lh-180 {
    line-height: 1.8 !important;
}
.icon-primary {
    color: var(--primary);
    background-color:  var(--light-primary);
}
.icon-shape {
    display: inline-block;
    align-items: center;
    justify-content: center;
    text-align: center;
    border-radius: 0.25rem;
}
.icon-sm {
    min-width: 2rem;
    min-height: 2rem;
    line-height: 2rem;
}
.rounded-circle {
    border-radius: 50% !important;
}

</style>